<template>
	<div class="regionBudget">
		<confirmRegion
			:removeRegionList="removeRegionList"
			:importantRegionList="importantRegionList"
			@getlistData="getListData"
			@confirmRemove="confirmRemove"
			@confirmLocation="confirmLocation"
		></confirmRegion>
		<div class="confirmBudget">
			<div class="budget_title">确认预算</div>
			<div class="budget_subtitle">预算说明</div>
			<dayBudget :onlinePlanDetails="onlinePlanDetails" ref="dayBudget"></dayBudget>
		</div>
		<confirmStep
			:activeValue="4"
			@toNext="toNext"
			@toPrev="toPrev"
			@toSkip="toSkip"
			class="footer"
		></confirmStep>
	</div>
</template>
<script>
import confirmRegion from '@/components/adsOnlineAuto/com/confirmRegion.vue';
import dayBudget from '@/components/googleAdsCom/newHomeOnline/components/dayBudget';
import confirmStep from '@/components/adsOnlineAuto/confirmStep';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	props: ['bindvalue'],
	components: {
		confirmRegion,
		dayBudget,
		confirmStep,
	},
	data() {
		return {
			removeRegionList: [],
			importantRegionList: [],
			budgetType: '',
			budgetVal: '',
			regionId: '',
			onlinePlanDetails: { budget: 500 },
		};
	},
	computed: {
		automationId() {
			return this.$route.query.id;
		},
	},
	methods: {
		async productregion() {
			let res = await adsNewOnlineSer.productregion({
				id: this.automationId,
			});
			if (res.data) {
				const regionInfo = res.data;
				const { regionId, budgetType, budgetVal, removeRegionList, importantRegionList } =
					regionInfo;
				this.regionId = regionId;
				this.budgetType = budgetType;
				this.budgetVal = budgetVal;
				this.removeRegionList = removeRegionList;
				this.importantRegionList = importantRegionList;
				this.$set(this.onlinePlanDetails, 'budget', this.budgetVal);
			}
		},
		async addproductregion(param) {
			let budgetVal = this.$refs.dayBudget.getData();
			// 取消俄罗斯注释
			// let removeList = this.removeRegionList
			// 	? this.removeRegionList.filter(
			// 			item => item.regionName !== '苏丹' && item.regionName !== '俄罗斯'
			// 	  )
			// 	: [];
			let removeList = this.removeRegionList
				? this.removeRegionList.filter(item => item.regionName !== '苏丹')
				: [];
			try {
				let res = await adsNewOnlineSer.addproductregion({
					automationId: this.automationId,
					budgetVal: budgetVal.budget,
					importantRegionList: this.importantRegionList,
					regionId: this.regionId,
					removeRegionList: removeList,
					showFlag: param ? 1 : 0,
				});
				if (res.data == 'success') {
					this.$store.dispatch('getstepstatus', this.automationId);
					if (param) {
						this.$emit('toSkip', 6);
					} else {
						this.$emit('toNext');
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		unique(arr) {
			const res = new Map();
			return arr.filter(arr => !res.has(arr.regionId) && res.set(arr.regionId, 1));
		},
		confirmRemove(val) {
			let obj1 = JSON.parse(JSON.stringify(val).replace(/id/g, 'regionId'));
			let obj2 = JSON.parse(JSON.stringify(obj1).replace(/name/g, 'regionName'));
			let arr = this.removeRegionList;
			let list = arr.concat(...obj2);
			this.removeRegionList = this.unique(list);
		},
		confirmLocation(val) {
			let obj1 = JSON.parse(JSON.stringify(val).replace(/id/g, 'regionId'));
			let obj2 = JSON.parse(JSON.stringify(obj1).replace(/name/g, 'regionName'));
			let arr = this.importantRegionList ? this.importantRegionList : [];
			let list = arr.concat(...obj2);
			this.importantRegionList = this.unique(list);
		},
		getListData(excludeList, keylist) {
			let obj1 = JSON.parse(JSON.stringify(excludeList).replace(/id/g, 'regionId'));
			this.removeRegionList = JSON.parse(JSON.stringify(obj1).replace(/value/g, 'regionName'));
			let obj2 = JSON.parse(JSON.stringify(keylist).replace(/id/g, 'regionId'));
			this.importantRegionList = JSON.parse(JSON.stringify(obj2).replace(/value/g, 'regionName'));
		},
		toNext(param) {
			if (this.$refs.dayBudget.radio) {
				this.addproductregion(param);
			} else {
				let boolean = this.$refs.dayBudget.validation();
				if (boolean) {
					this.addproductregion(param);
				}
			}
		},
		toPrev() {
			this.$emit('toPrev', this.bindvalue);
		},
		toSkip() {
			this.toNext(1);
		},
	},
	created() {
		this.productregion();
	},
};
</script>
<style lang="scss" scoped>
.confirmBudget {
	height: 320px;
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	padding: 20px 25px;
	margin-bottom: 10px;

	.budget_title {
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 40px;
	}

	.budget_subtitle {
		margin: 30px 0;
		text-align: center;
	}
}
</style>
